import { SchemaFormFields } from '@mews-commander/form';
import { createOption, OptimusProvider } from '@mews-commander/ui';
import { primitiveTypeUniq } from '@mews/fp';
import { useGetServiceNamesByIdQuery } from '../../common/queries/useGetServiceNamesByIdQuery';
import { useCurrentEnterpriseAttachments } from '../../common/hooks/useCurrentEnterpriseAttachments';
import { attachmentsTableFilterSchema, attachmentsTableFiltersFormDefinition } from './AttachmentLibraryFilters';

export const AttachmentsTableFiltersForm = () => {
    const attachments = useCurrentEnterpriseAttachments();

    const serviceIds = attachments
        ? primitiveTypeUniq(attachments?.flatMap((attachment) => attachment.services.map(({ id }) => id)))
        : [];

    const { data: serviceNamesById } = useGetServiceNamesByIdQuery();

    const serviceOptions = serviceIds.map((id) =>
        createOption({
            value: id,
            label: serviceNamesById[id],
        })
    );

    return (
        <OptimusProvider density="spacious">
            <SchemaFormFields
                schema={attachmentsTableFilterSchema}
                formDefinition={attachmentsTableFiltersFormDefinition({ serviceOptions })}
            />
        </OptimusProvider>
    );
};
